export default __webpack_public_path__ + "static/media/bomb.117a0480.png";